import { createStore } from '@abyss/web/tools/createStore';

import { UserDDPCode } from '../../models/Provider';
import {
  State,
  StoreKeys,
  featureSuppressionUIState,
  intialUIState,
} from './state';

const initialState: State = {
  [StoreKeys.SESSION_ID]: '',
  [StoreKeys.PLAN_SELECTOR]: {
    bigN: {
      DOB: '',
      FirstName: '',
      GroupNumber: '',
      LastName: '',
      MemberNumber: '',
      portalSource: '',
      userName: '',
      id: '',
    },
    isLoggedInMember: false,
  },
  [StoreKeys.OTHER_PLANS_SELECTOR]: {
    bigN: {
      DOB: '',
      FirstName: '',
      GroupNumber: '',
      LastName: '',
      MemberNumber: '',
      portalSource: '',
      userName: '',
      id: '',
    },
  },
  [StoreKeys.OBAPI_MEMBERS]: [],
  [StoreKeys.UI_STATE]: intialUIState,
  [StoreKeys.UI_FEATURE_SUPPRESSION]: featureSuppressionUIState,
  [StoreKeys.NAVIGATION_HISTORY]: {
    previousPageName: '',
    previousPageRank: 0,
    currentPageName: '',
    currentPageRank: 0,
  },
  [StoreKeys.BREADCRUMB_CLICKED_FLAG]: false,
  [StoreKeys.MEMBER_SELECTION_POPUP_FLAG]: false,
  [StoreKeys.TIER1_PLAN_FLAG]: false,
  [StoreKeys.IS_WIDGET]: false,
  [StoreKeys.COVERAGE_TYPE]: '',
  [StoreKeys.USER_DDP_CODE]: 'N' as UserDDPCode,
  [StoreKeys.RESULTS_HAS_PROVIDER_WITH_UPCOMING_AVAILABILITY]: false,
  [StoreKeys.DISTANCE_FILTER_DONT_SHOW_BUTTON_CLICKED_DATE]: '',
  [StoreKeys.EDUCATIONAL_CONTENT_STATUS]: undefined,
  [StoreKeys.SHOW_SMART_CHOICE_LEVEL1_BREAKDOWN]: false,
  [StoreKeys.SHOW_SMART_CHOICE_LEVEL3_BREAKDOWN]: false,
  [StoreKeys.DRAWER_TYPE]: ['', ''],
  [StoreKeys.SHOW_AOE_WIDGET_PAGE]: false,
};

export const useStore = createStore((set) => ({
  ...initialState,
  [StoreKeys.SET_SESSION_ID]: (sessionId) => set(() => ({ sessionId })),
  [StoreKeys.SET_PLAN_SELECTOR]: (planSelector) =>
    set(() => ({ planSelector })),
  [StoreKeys.SET_OTHER_PLANS_SELECTOR]: (otherPlansSelector) =>
    set(() => ({ otherPlansSelector })),
  [StoreKeys.SET_OBAPI_MEMBERS]: (memberInfo) =>
    set(() => ({
      memberInfo: memberInfo?.filter(
        (member) =>
          !!member.eligibility[0]?.memberHealthCoverage?.coverageType?.length
      ),
    })),
  [StoreKeys.SET_UI_STATE]: (uiState) => set(() => ({ uiState })),
  [StoreKeys.SET_UI_FEATURE_SUPPRESSION]: (featureSuppressionUIstate) =>
    set(() => ({ featureSuppressionUIstate })),
  [StoreKeys.SET_UI_FEATURE_INCLUSION]: (featureInclusionUIstate) =>
    set(() => ({ featureInclusionUIstate })),
  [StoreKeys.SET_NAVIGATION_HISTORY]: (navigationHistory) =>
    set(() => ({ navigationHistory })),
  [StoreKeys.SET_BREADCRUMB_CLICKED_FLAG]: (hasBreadCrumbClickedFlag) =>
    set(() => ({ hasBreadCrumbClickedFlag })),
  [StoreKeys.SET_MEMBER_SELECTION_POPUP_FLAG]: (memberSelectionPopupFlag) =>
    set(() => ({ memberSelectionPopupFlag })),
  [StoreKeys.SET_TIER1_PLAN_FLAG]: (isTier1Plan) =>
    set(() => ({ isTier1Plan })),
  [StoreKeys.SET_IS_WIDGET]: (isWidget) => set(() => ({ isWidget })),
  [StoreKeys.SET_COVERAGE_TYPE]: (coverageType) =>
    set(() => ({ coverageType })),
  [StoreKeys.SET_PRE_PROD_TOGGLE]: (enablePreProd) =>
    set(() => ({ enablePreProd })),
  [StoreKeys.SET_USER_DDP_CODE]: (userDDPCode) => set(() => ({ userDDPCode })),
  [StoreKeys.SET_RESULTS_HAS_PROVIDER_WITH_UPCOMING_AVAILABILITY]: (
    resultsHasProviderWithUpcomingAvailability
  ) => set(() => ({ resultsHasProviderWithUpcomingAvailability })),
  [StoreKeys.SET_RECOMMENDATION_PREFERENCES]: (recommendationPreferences) =>
    set(() => ({ recommendationPreferences })),
  [StoreKeys.SET_DETAILS_RECOMMENDATION_PREFERENCES]: (
    detailsRecommendationPreferences
  ) => set(() => ({ detailsRecommendationPreferences })),
  [StoreKeys.SET_DISTANCE_FILTER_DONT_SHOW_BUTTON_CLICKED_DATE]: (
    distanceFilterDontShowButtonClickedDate
  ) => {
    set(() => ({ distanceFilterDontShowButtonClickedDate }));
  },
  [StoreKeys.SET_UPCOMING_AVAILABILITY_FILTER_DONT_SHOW_BUTTON_CLICKED_DATE]: (
    upcomingAvailabilityFilterDontShowButtonClickedDate
  ) => {
    set(() => ({ upcomingAvailabilityFilterDontShowButtonClickedDate }));
  },
  [StoreKeys.SET_PRIORITY_SCHEDULING_FILTER_DONT_SHOW_BUTTON_CLICKED_DATE]: (
    prioritySchedulingFilterDontShowButtonClickedDate
  ) => {
    set(() => ({ prioritySchedulingFilterDontShowButtonClickedDate }));
  },
  [StoreKeys.SET_EDUCATIONAL_CONTENT_STATUS]: (educationalContentStatus) =>
    set(() => ({ educationalContentStatus })),
  [StoreKeys.SET_SHOW_SMART_CHOICE_LEVEL1_BREAKDOWN]: (
    showSmartChoiceLevel1Breakdown
  ) => set(() => ({ showSmartChoiceLevel1Breakdown })),
  [StoreKeys.SET_SHOW_SMART_CHOICE_LEVEL3_BREAKDOWN]: (
    showSmartChoiceLevel3Breakdown
  ) => set(() => ({ showSmartChoiceLevel3Breakdown })),
  [StoreKeys.SET_DRAWER_TYPE]: (drawerType) => set(() => ({ drawerType })),
  [StoreKeys.SET_SHOW_AOE_WIDGET_PAGE]: (showAoeWidgetPage) =>
    set(() => ({ showAoeWidgetPage })),
}));
